import { flow } from 'lodash';

import { NAME } from './receipts.constant';

import { selectModulesState } from '@giro-app/store/modules/modules.selector';

const selectState = (state) => state[NAME];

export const selectPaymentState = flow(selectModulesState, selectState);
